/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { htmlSafe } from '@ember/template';
import { SafeString } from 'handlebars';

interface WistiaEmbedArgs {
  id: string;
  onStart: () => unknown;
  onPause?: () => unknown;
  options?: [key: string, any];
}

export default class WistiaEmbed extends Component<WistiaEmbedArgs> {
  @tracked started = false;
  @tracked swatchOpacity = false;
  @tracked video: Record<string, any> | null = null;

  get onStart() {
    return this.args.onStart ?? (() => {});
  }

  get onPause() {
    return this.args.onPause ?? (() => {});
  }

  get swatchStyle(): SafeString {
    return htmlSafe(
      `height:100%;left:0;opacity:${
        this.swatchOpacity ? 1 : 0
      };overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;`,
    );
  }

  // See the Wistia API documentation
  // https://wistia.com/support/developers/player-api
  @action
  setupVideoApi() {
    window._wq = window._wq ?? [];
    window._wq.push({
      id: this.args.id,
      onReady: this.setupVideoBindings,
      options: this.args.options ?? null,
    });
  }

  willDestroy() {
    super.willDestroy();

    window._wq = window._wq?.filter((config) => config.id !== this.args.id);
  }

  @action
  setupVideoBindings(video: Record<string, any>) {
    this.video = video;

    this.video.bind('play', this.handleVideoPlayed);
    this.video.bind('pause', this.handleVideoPaused);
  }

  @action
  handleVideoPlayed() {
    if (!this.started) {
      this.started = true;
      this.onStart();
    }
  }

  @action
  handleVideoPaused() {
    if (this.started) {
      this.started = false;
      this.onPause();
    }
  }

  @action
  makeSwatchVisible() {
    this.swatchOpacity = true;
  }
}
